import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UpdateWishlistItemRequest {
  title: string;
  description?: string;
  link?: string;
}

interface UpdateWishlistItemResponse {
  id: string;
  user_id: string;
  relationship_id: string;
  title: string;
  description: string | null;
  link: string | null;
  created_at: string;
  updated_at: string;
}

export function useUpdateWishlistItem(relationshipId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      itemId,
      data,
    }: {
      itemId: string;
      data: UpdateWishlistItemRequest;
    }) => {
      const response = await api
        .patch(`relationships/${relationshipId}/wishlist/${itemId}`, {
          json: data,
        })
        .json<UpdateWishlistItemResponse>();
      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.relationship.byId(relationshipId),
      });
    },
  });
}
